<template>
  <div :class="ui.bkgdColor">
      <v-layout class="text-xs-right mt-2 mr-2">
        <v-spacer/>
        <v-btn :color="ui.btnColor"
        :disabled="
        this.disableNew ||
        getAttachmentList.length > 30 ||
        !this.enableDocumentItemAdd() ||
        this.getDetailChar.stat
        "
        flat @click="openDialog()">
          <v-icon left :color="ui.btnColor"> add </v-icon>
          Attachment
        </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
          <v-card-title class="title wplblue0--text">
            New Attachment
          </v-card-title>
          <v-progress-linear color="blue-grey" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                  v-model="localForm.title"
                  label="attachment title"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.theme"
                  :items="attachmentTheme"
                  label="theme"
                  prepend-icon="yard"
                  hint="attach. type"
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.type"
                  :items="attachmentType"
                  label="type"
                  prepend-icon="grid_view"
                  hint="attach. type"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.ref"
                  v-if="localForm.theme !== 'Comment'"
                  label="reference"
                  :rules="ruleMustBeNotUndefinedANDLessThan25"
                  prepend-icon="bookmark"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                  v-if="localForm.theme !== 'Comment'"
                  v-model="localForm.link"
                  label="web link / https"
                  :rules="mustBeLessThanLarge"
                  prepend-icon="link"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="mustBeLessThanLarge"
                  hint="attachment description"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" color="wplblue0" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate" color="wplblue0" flat
            >
              <v-icon left> add </v-icon>
              add
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import master from "@/data/forms/mixins/master.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import attachOptions from "@/data/options/mixins/attachOptions.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    attachOptions,
    listFunctions,
    generateForms,
    master,
    rulesTextfield,
    uisettings,
    generateID,
    docRevsModFunctions,
    documentFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getAttachmentList",
      "getAttachmentListPrior",
      "getAttachmentListCounter",
      "getAttachmentListDisplay",
      "getCurrentPage",
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getUser",
      "getPreviousPage"
    ]),
    ui() {
      return this.uiTheme1;
    },
    disableNew() {
      let logic = null;
      if (this.getDetailBasic.tag === "E8") {
        if (
          this.getDetailChar.stat === true ||
          this.getPreviousPage === "/reportlist" ||
          this.getPreviousPage === "/reportdetaillist"
        ) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinner: false,
      ctr: 0,
      attachLast: null,
      attachListLocal: [],
      localForm: {
        title: "",
        type: "",
        theme: "",
        link: "",
        ref: "",
        com: ""
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      // this.$store.dispatch("changeAttachmentList", []);
      // this.$refs.form.reset();
    },
    validate() {
      // cosole.log(this.taskForm)
      // this.$refs.form.validate() === true
      if (this.getAttachmentList !== null) {
        // NEW ATTACHMENT
        let tempForm = this.generateAttachmentForm();
        tempForm.basic.idg = this.generateIDG("date-gid");
        tempForm.basic.did = this.generateDID("auto");
        tempForm.basic.tag = "D4";
        tempForm.basic.idi = this.getAttachmentListCounter + 1;
        tempForm.basic.title = this.localForm.title;
        tempForm.char.link = this.localForm.link;
        tempForm.char.ref = this.localForm.ref;
        tempForm.char.com = this.localForm.com;
        tempForm.char.type = this.localForm.type;
        tempForm.char.theme = this.localForm.theme;
        tempForm.stats.date = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getAttachmentList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.appendItemLimited(parseobj, tempList, 50);

        // STORE UPDATE
        this.$store.dispatch("changeAttachmentList", newList);
        this.$store.dispatch("changeAttachmentListCounter", tempForm.basic.idi);
        this.saveDocumentRevMod(5.11, 1); // attachment added.
        this.$store.dispatch("changeDataSavePendingIndication", true);

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
